var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-piece",style:({
    gridColumn: ((_vm.record.column - 1) + " / " + (_vm.record.column)),
    gridRow: ((_vm.record.row) + " / " + (_vm.record.row + 1)),
  }),on:{"mouseenter":_vm.recordMouseover,"mouseleave":_vm.recordMouseout}},[_c('router-link',{attrs:{"to":{
    name: 'Record',
    params: {
      recordName: _vm.record.code,
      record: _vm.record
    }
  }}},[_c('img',{staticClass:"record-img",class:{
      selected: _vm.selected,
      softOpacity: _vm.softOpacity,
    },attrs:{"src":("https://storage.googleapis.com/cartografiadigital/records_icons/" + (_vm.record.code) + ".png")}}),_c('v-popover',{attrs:{"open":_vm.show,"delay":{show: 500},"placement":_vm.record.row < 20 ? 'bot' : 'top',"offset":"50"}},[_c('template',{slot:"popover"},[_c('section',{staticClass:"popover-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.record.title))]),_c('div',{staticClass:"author-and-year"},[_c('span',[_vm._v(_vm._s(_vm.record.author[0]))]),_c('span',[_vm._v(_vm._s(_vm.record.year ? (", " + (_vm.record.year)) : ''))])]),_c('div',{staticClass:"message"},[_vm._v(" Click para más información ")])])])],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }